import axios from 'axios'
import { host } from '../../helper/config'

const PLUGIN_NAME = 'admin-setting'

const buildHeaders = (token) => ({
  'Access-Control-Allow-Origin': '*',
  'Content-Type': 'application/json',
  Authorization: token,
})

export const getZaloOtpSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/zalo-otp/get`,
    {},
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateZaloOtpSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/zalo-otp/update`,
    payload,
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const fetchZaloOtpAccessToken = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/zalo-otp/fetch-access-token`,
    payload,
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data || null
  }
  return null
}

export const getSupportContactSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/support-contact/get`,
    {},
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateSupportContactSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/support-contact/update`,
    payload,
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getFeeSettings = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/fee/list`,
    {},
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.data || null
  }
  return null
}

export const updateFeeSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/fee/update`,
    payload,
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data || null
  }
  return null
}

export const bulkUpdateFeeSettings = async (token, settings) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/fee/bulk-update`,
    { settings },
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data || null
  }
  return null
}

export const getDepositWithdrawSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/deposit-withdraw/get`,
    {},
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateDepositWithdrawSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/deposit-withdraw/update`,
    payload,
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getSepaySetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/sepay/get`,
    {},
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getSepayBanks = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/sepay/banks`,
    {},
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.data || []
  }
  return []
}

export const updateSepaySetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/sepay/update`,
    payload,
    {
      headers: buildHeaders(token),
    }
  )

  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getDienToanCrawlerSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/dien-toan-crawler/get`,
    {},
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateDienToanCrawlerSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/dien-toan-crawler/update`,
    payload,
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getClassicPeriodAutoCreateSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/classic-period-auto-create/get`,
    {},
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateClassicPeriodAutoCreateSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/classic-period-auto-create/update`,
    payload,
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getKenoPrintCutoffSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/keno-print-cutoff/get`,
    {},
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.printCutoffOffsetSeconds ?? null
  }
  return null
}

export const updateKenoPrintCutoffSetting = async (token, printCutoffOffsetSeconds) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/keno-print-cutoff/update`,
    { printCutoffOffsetSeconds },
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.printCutoffOffsetSeconds ?? null
  }
  return null
}

export const getLotto535Setting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/lotto535/get`,
    {},
    { headers: buildHeaders(token) }
  )
  return response?.status === 200 ? response.data?.config || null : null
}

export const updateLotto535Setting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/lotto535/update`,
    payload,
    { headers: buildHeaders(token) }
  )
  return response?.status === 200 ? response.data?.config || null : null
}

export const getRewardTaxSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/reward-tax/get`,
    {},
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateRewardTaxSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/reward-tax/update`,
    payload,
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const getRewardFeeSetting = async (token) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/reward-fee/get`,
    {},
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}

export const updateRewardFeeSetting = async (token, payload) => {
  const response = await axios.post(
    `${host}/${PLUGIN_NAME}/reward-fee/update`,
    payload,
    { headers: buildHeaders(token) }
  )
  if (response && response.status === 200) {
    return response.data?.config || null
  }
  return null
}
